













































































































































































































































































































































































































































































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import IconChaperone from '@/assets/icons/chaperone.svg'; // not font-awesome
import Button from '@/components/Button.vue';
import Translation from '@/components/i18n/Translation.vue';
import BIObject from '@/types/taxcard/BIObject';
import TransitionExpand from '@/components/animation/TransitionExpand.vue';
import RadioSelectField from '@/components/form/RadioSelectField.vue';
import SelectField from '@/components/form/SelectField.vue';
import SelectOption from '@/types/form/SelectOption';
import TextField from '@/components/form/TextField.vue';
import DateField from '@/components/form/DateField.vue';
import CheckboxField from '@/components/form/CheckboxField.vue';
import AdditionalMandatoryField from '@/types/validation/AdditionalMandatoryField';
import { ValidationError } from 'class-validator';
import CommuneProjection from '@/types/projections/CommuneProjection';
import Loader from '@/components/Loader.vue';
import PriceDiscountOptionProjection from '@/types/projections/PriceDiscountOptionProjection';
import { Getter, namespace } from 'vuex-class';
import moment, { max, Moment } from 'moment';
import DiscountCheckboxField from '@/components/form/DiscountCheckboxField.vue';
import BirthdayField from '@/components/form/BirthdayField.vue';
import ImageUploadField from '@/components/form/ImageUploadField.vue';
import NewTranslation from '@/components/i18n/NewTranslation.vue';
import i18next from 'i18next';
import getCountries from '@/views/taxcard/booking/getCountries';
import AccommodationSelectOverlay from '@/views/taxcard/booking/AccommodationSelectOverlay.vue';
import AccommodationProjection from '@/types/projections/AccommodationProjection';
import BookingAccommodationDisplay from '@/views/taxcard/booking/BookingAccommodationDisplay.vue';
import BookingAddSavedPerson from '@/views/taxcard/booking/BookingAddSavedPerson.vue';
import { getWebConfigValOfElement, getMandatoryFieldsToValidate } from '@/views/utils/elementsValidationAndVisualization';
import GuestType, { GuestTypesEnum } from '@/types/taxcard/GuestType';
import AdditionalGuestTypeFields from '@/types/taxcard/AdditionalGuestTypeFields';
import CommuneGuestTypeOption from '@/types/taxcard/CommuneGuestTypeOption';
import { momentEndDay, momentStartDay } from '@/views/utils/timeCalculations';

const BookingModule = namespace('booking');

@Component({
  components: {
    BookingAccommodationDisplay,
    AccommodationSelectOverlay,
    BookingAddSavedPerson,
    NewTranslation,
    ImageUploadField,
    BirthdayField,
    DiscountCheckboxField,
    CheckboxField,
    TextField,
    SelectField,
    TransitionExpand,
    IconChaperone,
    Button,
    Translation,
    RadioSelectField,
    DateField,
    Loader,
  },
})
export default class BookingItem extends Vue {
  @Prop(Object)
  public bIObject!: BIObject;

  @Prop(Boolean)
  public isOpen!: boolean;

  @Prop(Number)
  public index!: number;

  @Prop(Object)
  public commune!: CommuneProjection;

  @Prop(Array)
  public communeGuestTypeOptions!: CommuneGuestTypeOption[];

  @Prop(Array)
  public additionalMandatoryFields!: AdditionalMandatoryField[];

  @Prop(Array)
  public mandatoryFields!: string[];

  @Prop(Number)
  public price!: number;

  @Prop(Boolean)
  public priceProjectionIsLoading!: boolean;

  @Prop(Boolean)
  public isChaperone!: boolean;

  @Prop(Boolean)
  public strictAccommodation!: boolean;

  @Getter('loggedInUser')
  public isLoggedIn!: boolean;

  @Getter('savedPeople')
  public savedPeople!: any;

  @BookingModule.Getter
  public accommodation!: AccommodationProjection;

  @BookingModule.Action('fetchCommuneDiscounts')
  public fetchCommuneDiscounts!: any;

  @BookingModule.Action('fetchAccommodation')
  public fetchAccommodation!: any;

  public discountsAreLoading: boolean = false;

  public priceDiscountOptions: PriceDiscountOptionProjection[] = [];
  public groupPriceDiscountOptions: PriceDiscountOptionProjection[] = [];

  public showPersonCount: boolean = false;

  public discountsOpen: boolean = false;

  public groupDiscountsOpen: boolean = false;

  public accommodationsSelectOpen = false;

  public savedPersonCompleteData: boolean = true;

  public savedPersonHalfData: boolean = true;

  public bIObjectAnnualYear: number = 0;

  public birthdayFieldComponentKey: number = 0;

  private isChild: boolean = false;

  private canUpdatePrices: boolean = false;

  // private optionValue: string = "";

  private onInfoClick = () => this.$router.push({ name: 'ticketInfoGuestType' });

  public created(): void {
    //Set default optionValue according to guestType and other properties
    // this.optionValue = findGuestTypeOptionRadioValue(this.onInfoClick, this.bIObject, this.commune);
    // console.log("BookingItem Created");
    this.setSavedVariables();
    if (this.bIObject.bIObjectData.guestType === GuestTypesEnum.overnight && this.bIObject.bIObjectData.personCount > 0) {
      this.showPersonCount = true;
    }

    const stayBeginYear = moment(this.bIObject.bIObjectData.stayBegin).year();
    const stayEndYear = moment(this.bIObject.bIObjectData.stayEnd).year();
    
    if (this.bIObjectAnnualYear == 0 && stayBeginYear == stayEndYear) {
      const yearOptions = this.annualYearOptions;
      const yearOptionFound = yearOptions.find((yearOption)=>{
        return yearOption.value == stayBeginYear;
      })
      if(yearOptionFound) {
        this.bIObjectAnnualYear = yearOptionFound.value as number;
      }
    }
    this.canUpdatePrices = true;
  }

  public setSavedVariables() {
    if (this.bIObject) {
      this.savedPersonCompleteData = !(
        this.bIObject.bIObjectData.addressStreetAndNumber === '' ||
        this.bIObject.bIObjectData.addressZipCode === '' ||
        this.bIObject.bIObjectData.addressCity === '' ||
        this.bIObject.bIObjectData.cellphoneNumber === ''
      );
      this.savedPersonHalfData = this.bIObject.bIObjectData.firstName !== '' && this.bIObject.bIObjectData.lastName !== '';
    }
  }

  // public copyInitialBIObject(initialBIObject: BIObject) {
  //   if (initialBIObject) {
  //     const bIObject = BIObject.hydrate(initialBIObject.dehydrate());
  //     if (bIObject) {
  //       this.bIObject = bIObject;
  //       this.savedPersonCompleteData = !(
  //         bIObject.addressStreetAndNumber === '' ||
  //         bIObject.addressZipCode === '' ||
  //         bIObject.addressCity === '' ||
  //         bIObject.cellphoneNumber === ''
  //       );
  //       this.savedPersonHalfData = bIObject.firstName !== '' && bIObject.lastName !== '';
  //     }
  //   }
  // }

  public get annualYearOptions(): Array<SelectOption> {
    const currentYear = moment().year();
    let yearOptions = [{ value: 0, label: 'Jahr' }];

    for (let i = currentYear; i <= currentYear + 1; i++) {
      yearOptions.push({ value: i, label: `${i}` });
    }

    return yearOptions;
  }

  public get annualCardResidenceTypeOptions(): Array<SelectOption> {
    // const types = ['','secondary_residence', 'pitch', 'long_term_stay', 'berth'];
    return [
      { value: '', label: '' },
      { value: 'secondary_residence', label: i18next.t('booking.annualCardResidenceType.secondary_residence') as string },
      { value: 'pitch', label: i18next.t('booking.annualCardResidenceType.pitch') as string },
      { value: 'long_term_stay', label: i18next.t('booking.annualCardResidenceType.long_term_stay') as string },
      { value: 'berth', label: i18next.t('booking.annualCardResidenceType.berth') as string },
    ];
  }

  public get getAccommodation():AccommodationProjection {
    const uid = (this.bIObject.bIObjectData.accommodation as any).id;
    const communeId = (this.bIObject.bIObjectData.accommodation as any).communeId;
    if (uid !== undefined && communeId !== undefined) {
      this.loadAccommodation(communeId, uid);
    }
    return this.bIObject.bIObjectData.accommodation;
  }

  public async loadAccommodation(communeId: number, uid: number) {
    const newData = await this.fetchAccommodation({
      communeId: communeId,
      uid: uid,
    }).then((data: any) => {
      return data;
    });
    this.compareAccommodations(newData);
  }

  public compareAccommodations(newAccommodation: AccommodationProjection) {
    if (
      this.isAccommodationAProjection(this.bIObject.bIObjectData.accommodation) &&
      (this.bIObject.bIObjectData.accommodation.id !== newAccommodation.id ||
        this.bIObject.bIObjectData.accommodation.identificationNr !== newAccommodation.identificationNr ||
        this.bIObject.bIObjectData.accommodation.name !== newAccommodation.name ||
        this.bIObject.bIObjectData.accommodation.addressStreetAndNumber !== newAccommodation.addressStreetAndNumber ||
        this.bIObject.bIObjectData.accommodation.addressZip !== newAccommodation.addressZip ||
        this.bIObject.bIObjectData.accommodation.addressCity !== newAccommodation.addressCity ||
        this.bIObject.bIObjectData.accommodation.providerName !== newAccommodation.providerName ||
        this.bIObject.bIObjectData.accommodation.communeId !== newAccommodation.communeId ||
        this.bIObject.bIObjectData.accommodation.active !== newAccommodation.active)
    ) {
      this.bIObject.bIObjectData.accommodation = newAccommodation;
    }
  }

  isAccommodationAProjection(accommodation: {} | AccommodationProjection): accommodation is AccommodationProjection {
    if ((accommodation as AccommodationProjection).id) {
      return true;
    }
    return false;
  }

  public get canSavePerson(): boolean {
    return (
      this.isLoggedIn &&
      !this.isAnonymous() &&
      !this.savedPersonCompleteData &&
      !(this.isDayGuest() && this.savedPersonHalfData)
    );
  }

  public get translationlocationSection(): string {
    return `booking.locationSection.title.${this.bIObject.bIObjectData.guestType}`;
  }

  @Watch('commune', { immediate: true })
  public onCommuneChange(commune: CommuneProjection) {
    this.bIObject.bIObjectData.option = {};
    const bIObject = this.bIObject;
    this.loadAndSetDiscounts(this.commune, bIObject);
  }

  @Watch('bIObject.bIObjectData.stayBegin', { immediate: true })
  public onStayBeginChange(stayBegin: Moment) {
    const bIObject = { ...this.bIObject, stayBegin };
    this.adjustStayEndForGuestType();
    this.loadAndSetDiscounts(this.commune, bIObject);
  }

  @Watch('bIObject.bIObjectData.stayEnd', { immediate: true })
  public onStayEndChange(stayEnd: any) {
    const bIObject = { ...this.bIObject, stayEnd };
    this.loadAndSetDiscounts(this.commune, bIObject);
  }

  @Watch('bIObject.bIObjectData.birthday', { immediate: true })
  public onBirthdayChange(birthday: Moment) {
    const bIObject = { ...this.bIObject, birthday };
    this.loadAndSetDiscounts(this.commune, bIObject);
    //Check/Set if it is a kid
    const now = moment.utc();
    const age = now.diff(moment.utc(birthday), 'years');
    this.isChild = age < 18;
    this.showPersonCount = false;
  }

  @Watch('bIObject.bIObjectData.firstName', { immediate: true })
  public onFirstNameChange(firstName: string) {
    const bIObject = { ...this.bIObject, firstName };
    this.loadAndSetDiscounts(this.commune, bIObject);
  }

  @Watch('bIObject.bIObjectData.lastName', { immediate: true })
  public onLastNameChange(lastName: string) {
    const bIObject = { ...this.bIObject, lastName };
    this.loadAndSetDiscounts(this.commune, bIObject);
  }

  @Watch('bIObject.bIObjectData.annualCardKey', { immediate: true })
  public onAnnualBIObjectKeyChange(annualCardKey: string) {
    const bIObject = { ...this.bIObject, annualCardKey };
    this.loadAndSetDiscounts(this.commune, bIObject);
  }

  @Watch('bIObject.bIObjectData.isAnonymous')
  public onAnonymousStateChange(isAnonymous: boolean) {
    this.$emit('anonymous-change', isAnonymous, this.bIObject);
  }

  @Watch('bIObject.bIObjectData.guestType')
  public onGuestTypeChange(guestType: GuestType) {
    // if (guestType === GuestTypesEnum.overnight) {
    if (guestType === GuestTypesEnum.overnight) {
      // this.$emit('input', GuestTypesEnum.overnight);
      this.bIObject.bIObjectData.isAnonymous = false;
    }
    if (guestType !== GuestTypesEnum.donation) {
      this.bIObject.bIObjectData.donationValue = 0;
    }
    
    if (guestType === GuestTypesEnum.day && this.commune.webConfiguration && this.commune.webConfiguration.defaultIsAnonymous) {
      this.bIObject.bIObjectData.isAnonymous = true;
    }
    this.adjustDatesForGuestType();
    this.$emit('guest-type-change', this.bIObject);
  }

  public emitUpdatePrices(): void {
    this.$emit('update-prices');
  }

  public loadAndSetDiscounts(commune: CommuneProjection, bIObject: any): void {
    if (commune && commune.id && !this.discountsAreLoading) {
      this.discountsAreLoading = true;

      this.fetchCommuneDiscounts({ communeId: commune.id, bIObject })
        .then((discounts: PriceDiscountOptionProjection[]) => {
          this.priceDiscountOptions = [];
          this.groupPriceDiscountOptions = [];

          discounts.forEach((discount) => {
            if (discount.isGroupDefinition) {
              this.groupPriceDiscountOptions.push(discount);
            } else {
              this.priceDiscountOptions.push(discount);
            }
          });
        })
        .catch((e: any) => {
          console.log('Failed to fetch commune discounts', e);
          this.priceDiscountOptions = [];
        })
        .then(() => (this.discountsAreLoading = false));
    }
  }

  @Emit()
  public toggleOpen(): void {}

  @Emit()
  public remove(): void {}

  @Watch('bIObject.bIObjectData', { immediate: false, deep: true })
  public onBIObjectChange(bIObject: BIObject, oldVal:BIObject): void {
    if (this.canUpdatePrices) {
      this.emitUpdatePrices();
    }
  }

  @Watch('showPersonCount')
  public onShowPersonCount(val:boolean, oldVal:boolean): void {
    if (oldVal != val && !val) {
      this.bIObject.bIObjectData.personCount = 0
    }
  }

  @Watch('bIObject.additionalGuestTypeFields.ridingTollTicketType', { immediate: true })
  public onRidingTollTicketTypeChange(val:number, oldVal:number): void {
    if (this.bIObject.bIObjectData.subGuestType == 'ridingTollTicket' && oldVal != val) {
      if (val == 1) {
        this.bIObject.bIObjectData.stayEnd = momentEndDay(moment(this.bIObject.bIObjectData.stayBegin));
      } else if(val == 3) {
        this.bIObject.bIObjectData.stayEnd = momentEndDay(moment(this.bIObject.bIObjectData.stayBegin)).add(2, 'days');
      }
    }
  }

  public get title(): string {
    const { firstName, lastName } = this.bIObject.bIObjectData;
    if (firstName || lastName) {
      return `${firstName} ${lastName}`;
    } else {
      return '';
    }
  }

  // public get guestTypeOptions(): Array<RadioSelectGuestTypeOption> {
  //   return guestTypeOptions(this.onInfoClick, this.commune);
  // }

  // private findGuestTypeOptionRadioValue() {
  //   const options = this.guestTypeOptions;
  //   for (let index = 0; index < options.length; index++) {
  //     const option = options[index];
  //     if (option.guestType == this.bIObject.bIObjectData.guestType && option.isAnnual == this.bIObject.bIObjectData.isAnnual && option.subGuestType == this.bIObject.bIObjectData.subGuestType){
  //       return `radioGuestType-${index}`;
  //     }
  //   }
  //   console.log("Reaching end of findGuestTypeOptionRadioValue");
  //   return 'radioGuestType-0';
  // }

  // public get guestTypeOptions(): Array<RadioSelectGuestTypeOption> {
  //   const onInfoClick = () => this.$router.push({ name: 'ticketInfoGuestType' });
  //   const result: Array<RadioSelectGuestTypeOption> = [];

  //   if (this.commune.overnightGuests) {
  //     result.push({
  //       hasInfo: true,
  //       onInfoClick,
  //       guestType: GuestTypesEnum.overnight,
  //       label: 'booking.guestType.overnight.label',
  //       isAnnual: false,
  //       subGuestType: ''
  //     });
  //   }
  //   if (this.commune.dayTrippers) {
  //     let label = 'booking.guestType.day.label';
  //     if (this.commune.id === 1801) {
  //       label = 'booking.cuxhaven.guestType.day.label';
  //     }
  //     result.push({
  //       hasInfo: true,
  //       onInfoClick,
  //       guestType: GuestTypesEnum.day,
  //       label,
  //       isAnnual: false,
  //       subGuestType: ''
  //     });
  //   }
  //   if (this.commune.isAnnualTicketActive) {
  //     result.push({
  //       hasInfo: true,
  //       onInfoClick,
  //       guestType: GuestTypesEnum.overnight,
  //       label: 'booking.annualCard.label',
  //       isAnnual: true,
  //       subGuestType: ''
  //     });
  //   }
  //   if (this.commune.hasDonations) {
  //     result.push({
  //       hasInfo: true,
  //       onInfoClick,
  //       guestType: GuestTypesEnum.donation,
  //       label: 'booking.donation.label',
  //       isAnnual: false,
  //       subGuestType: ''
  //     });
  //   }
  //   console.log("Communes", this.commune);

  //   if (this.commune.additionalGuestTypes && this.commune.additionalGuestTypes.length > 0) {
  //     const additionalGuestTypes = this.commune.additionalGuestTypes;
  //     for (let ind1 = 0; ind1 < additionalGuestTypes.length; ind1++) {
  //       const additionalGuestType = additionalGuestTypes[ind1];
  //       const additionalGuestTypeDivided = additionalGuestType.split('#');
  //       let finalGuestTypeString = additionalGuestTypeDivided[0];
  //       let finalGuestType = GuestTypesEnum.overnight;
  //       if (GuestTypesEnum.hasOwnProperty(finalGuestTypeString)) {
  //         finalGuestType = GuestTypesEnum[finalGuestTypeString];
  //       }
  //       let finalSubGuestType = '';
  //       let finalLabelString = `booking.guestType.${finalGuestType}.label`;
  //       if (additionalGuestTypeDivided.length > 1) {
  //         finalSubGuestType = additionalGuestTypeDivided[1];
  //         finalLabelString = `booking.guestType.${finalGuestType}.${finalSubGuestType}.label`;
  //       }
  //       const guestType = 
  //       result.push({
  //         hasInfo: false,
  //         onInfoClick,
  //         guestType: finalGuestType,
  //         label: finalLabelString,
  //         isAnnual: false,
  //         subGuestType: finalSubGuestType
  //       })
  //     }
  //   }
  //   // result.push({
  //   //   hasInfo: true,
  //   //   onInfoClick,
  //   //   guestType: GuestTypesEnum.overnight,
  //   //   label: 'booking.specialSubGuestType.label',
  //   //   isAnnual: false,
  //   //   subGuestType: 'RidingTollTicket1Day'
  //   // })

  //   return result;
  // }

  // public get canDisplayAnnualCard(): Boolean {
  // return !this.isAnonymous();
  // }

  public addSavedPerson(): void {
    this.$store.commit('openOverlay', {
      overlayName: 'SavedPeople',
      overlayData: {
        callback: this.onAddPerson,
      },
    });
  }

  public onAddPerson(person: any) {
    const p = person || {};
    this.bIObject.bIObjectData.salutation = !!p.salutation ? p.salutation : '';
    this.bIObject.bIObjectData.title = !!p.title ? p.title : '';
    this.bIObject.bIObjectData.firstName = !!p.firstName ? p.firstName : '';
    this.bIObject.bIObjectData.lastName = !!p.lastName ? p.lastName : '';
    this.bIObject.bIObjectData.birthday = !!p.birthday ? moment.utc(p.birthday) : null;
    this.updateBirthdayComponent();
    this.bIObject.bIObjectData.addressStreetAndNumber = !!p.addressStreetAndNumber ? p.addressStreetAndNumber : '';
    this.bIObject.bIObjectData.addressZipCode = !!p.addressZip ? p.addressZip : '';
    this.bIObject.bIObjectData.addressCity = !!p.addressCity ? p.addressCity : '';
    this.bIObject.bIObjectData.cellphoneNumber = !!p.phone ? p.phone : '';
    this.bIObject.bIObjectData.email = !!p.mail ? p.mail : '';

    this.savedPersonCompleteData = !(
      this.bIObject.bIObjectData.addressStreetAndNumber === '' ||
      this.bIObject.bIObjectData.addressZipCode === '' ||
      this.bIObject.bIObjectData.addressCity === '' ||
      this.bIObject.bIObjectData.cellphoneNumber === ''
    );
    this.savedPersonHalfData = this.bIObject.bIObjectData.firstName !== '' && this.bIObject.bIObjectData.lastName !== '';
  }

  private updateBirthdayComponent() {
    this.birthdayFieldComponentKey += 1;
  }

  public get salutationOptions(): Array<SelectOption> {
    return [
      { value: '', label: '' },
      { value: 'MR', label: i18next.t('salutation.MR') as string },
      { value: 'MRS', label: i18next.t('salutation.MRS') as string },
      { value: 'NONE', label: i18next.t('salutation.NONE') as string },
    ];
  }

  public get ridingTollTicketOptions(): Array<SelectOption> {
    return [
      { value: '1', label: i18next.t('ridingTollTicketOption.1Day') as string },
      { value: '3', label: i18next.t('ridingTollTicketOption.3Day') as string }
    ];
  }

  public get titleOptions(): Array<SelectOption> {
    return [
      { value: '', label: '' },
      {
        value: i18next.t('booking.title.option.PHD') as string,
        label: i18next.t('booking.title.option.PHD') as string,
      },
      {
        value: i18next.t('booking.title.option.PROF') as string,
        label: i18next.t('booking.title.option.PROF') as string,
      },
      {
        value: i18next.t('booking.title.option.PHDPROF') as string,
        label: i18next.t('booking.title.option.PHDPROF') as string,
      },
      {
        value: i18next.t('booking.title.option.ENG') as string,
        label: i18next.t('booking.title.option.ENG') as string,
      },
      {
        value: i18next.t('booking.title.option.ENGMASTER') as string,
        label: i18next.t('booking.title.option.ENGMASTER') as string,
      },
      {
        value: i18next.t('booking.title.option.MAG') as string,
        label: i18next.t('booking.title.option.MAG') as string,
      },
    ];
  }

  public get petCountOptions(): Array<SelectOption> {
    if (this.disabilityOptionChaperoneIsPet) {
      return [{ value: 1, label: 1 }];
    }
    const result = [];
    for (let i = 0; i <= 10; i++) {
      result.push({ value: i, label: i });
    }
    return result;
  }

  public get personCountOptions(): Array<SelectOption> {
    const result = [];
    if (this.bIObject.bIObjectData.guestType === GuestTypesEnum.overnight && this.showPersonCount && this.index===0) {
      for (let i = 0; i <= 500; i++) {
        result.push({ value: i, label: i });
      }
    } else {
      for (let i = 1; i <= 500; i++) {
        result.push({ value: i, label: i });
      }
    }
    return result;
  }

  // public get overnightPersonCountOptions(): Array<SelectOption> {
  //   const result = [];
  //   for (let i = 0; i <= 500; i++) {
  //     result.push({ value: i, label: i });
  //   }
  //   return result;
  // }

  public get countryOptions(): Array<SelectOption> {
    return [
      { value: '', label: i18next.t('booking.country.placeholder') as string },
      ...getCountries().map(c => ({ value: c, label: i18next.t(`country.${c}`) as string })),
    ];
  }

  public get nationalityOptions(): Array<SelectOption> {
    return [
      { value: '', label: i18next.t('booking.nationality.placeholder') as string },
      ...getCountries().map(c => ({ value: c, label: i18next.t(`country.${c}`) as string })),
    ];
  }  

  public isDayGuest(): boolean {
    return this.bIObject.bIObjectData.guestType === GuestTypesEnum.day;
  }

  get isOvernightGuest(): boolean {
    return this.bIObject.bIObjectData.guestType === GuestTypesEnum.overnight;
  }

  public isAnonymous(): boolean {
    return this.bIObject.bIObjectData.isAnonymous;
  }

  public isAnnual(): boolean {
    return !!this.bIObject.bIObjectData.isAnnual;
  }

  public isDonation(): boolean {
    return this.bIObject.bIObjectData.guestType === GuestTypesEnum.donation;
  }

  public disabledStayEnd(): boolean {
    
    return (this.isDayGuest() && (this.commune.dayGuestOnlyToday || this.commune.dayGuestOnlyOneDay)) || 
    (this.bIObject.bIObjectData.subGuestType == 'niederrhein4DayTicket' || this.bIObject.bIObjectData.subGuestType == 'niederrhein365DayTicket');
  }

  public get warnings(): { property: string; message: string }[] {
    const warnings: { property: string; message: string }[] = [];

    const bIObject = this.bIObject;
    if (!bIObject.bIObjectData.isAnonymous && !bIObject.bIObjectData.isAnnual) {
      const now = moment();
      if (bIObject.bIObjectData.stayBegin && moment(bIObject.bIObjectData.stayBegin).isBefore(now, 'day')) {
        warnings.push({ property: 'stayBegin', message: i18next.t('taxcard.pastDate.warning') });
      }
      if (bIObject.bIObjectData.stayEnd && moment(bIObject.bIObjectData.stayEnd).isBefore(now, 'day')) {
        warnings.push({ property: 'stayEnd', message: i18next.t('taxcard.pastDate.warning') });
      }
      //We cannot book a taxcard for more than a year
      if (bIObject.bIObjectData.stayBegin && bIObject.bIObjectData.stayEnd && moment(bIObject.bIObjectData.stayEnd).diff(moment(bIObject.bIObjectData.stayBegin), 'days', true) >= 367.0) {
        warnings.push({ property: 'stayEnd', message: i18next.t('taxcard.maxYear.warning') });
      }
    }

    return warnings;
  }

  public isMandatoryElement(fieldOrSectionName: string): boolean {
    const getMandatoryFields = getMandatoryFieldsToValidate(this.bIObject, this.additionalMandatoryFields);
    const foundField = getMandatoryFields.find((mandatoryField) => {
      return mandatoryField == fieldOrSectionName;
    })
    return foundField != undefined
  }

  public canDisplayElement(fieldOrSectionName: string):boolean {
    let defaultValue = false;
    const isMandatoryField = this.isMandatoryElement(fieldOrSectionName);
    if(isMandatoryField) {
      defaultValue = true
    }
    const webConfig = this.commune.webConfiguration;
    
    switch (fieldOrSectionName) {
      case 'accommodation':
          return defaultValue || this.isOvernightGuest;
      case 'stayBegin':
        break;
      case 'stayEnd':
        // return true;
        if (this.bIObject.bIObjectData.subGuestType == 'ridingTollTicket' ||
         (this.isDayGuest() && (this.commune.dayGuestOnlyToday || this.commune.dayGuestOnlyOneDay))
        ) {
          return false;
        }
        return defaultValue;
        break;
      case 'annualYear':
        break;
      case 'annualCardResidenceType':
        break;
      case 'annualCardKey':
          return this.isAnnual()
      case 'useBookingNo':
          return defaultValue || !!this.getAccommodation.useBookingNo;
      case 'annualCardPhoto':
        break;
      case 'addSavedPersonButton':
          return defaultValue || (this.savedPeople && this.savedPeople.length > 0 && !this.isAnonymous() && !this.isDonation());
      case 'isAnonymous':
          return defaultValue || (this.isDayGuest() && !this.isDonation() && getWebConfigValOfElement('isAnonymous', webConfig));
      case 'salutation':
        break;
      case 'title':
          return defaultValue || 
          (!this.isAnonymous() && !this.isDonation() && (this.bIObject.bIObjectData.subGuestType != 'niederrhein4DayTicket' && this.bIObject.bIObjectData.subGuestType != 'niederrhein365DayTicket'));
      case 'firstName':
        break;
      case 'lastName':
        break;
      case 'birthday':
          return defaultValue || (!this.isAnonymous() && !this.isDonation());
      case 'addressStreetAndNumber':
          return defaultValue;
      case 'addressZipCode':
          return defaultValue;
      case 'addressCity':
          return defaultValue;
      case 'addressCountry':
          return defaultValue;
      case 'nationality':
          break;
      case 'cellphoneNumber':
          return defaultValue;
      case 'email':
          return defaultValue || getWebConfigValOfElement('email', webConfig);
      case 'donationValue':
        break;
      case 'showPersonCount':
          return defaultValue || (this.bIObject.bIObjectData.guestType === GuestTypesEnum.overnight && this.index === 0);
      case 'personCount':
          return defaultValue || (this.isAnonymous() && !this.isDonation()) ||
            (this.bIObject.bIObjectData.guestType === GuestTypesEnum.overnight && this.showPersonCount && this.index === 0);
      case 'petCount':
          return defaultValue || (getWebConfigValOfElement('petCount', webConfig) && !this.isDonation());
      case 'childCount':
          return defaultValue || (getWebConfigValOfElement('childCount', webConfig) && !this.isDonation() && this.bIObject.bIObjectData.subGuestType != 'ridingTollTicket');
      case 'discountOptions':
          return defaultValue || (this.hasOptions && !this.isAnonymous() && !this.isChaperone && !this.isDonation());
      case 'groupDiscountOptions':
          return defaultValue || (this.hasGroupOptions && !this.isAnonymous() && !this.isChaperone && !this.isDonation() && this.showPersonCount);
      case 'priceSection':
          return defaultValue || (!this.isAnonymous() && !this.isDonation());
      case 'savePersonSection':
          return defaultValue || (this.canSavePerson && !this.isDonation());
      case 'ridingTollTicketTypeSelector':
          return defaultValue || this.bIObject.bIObjectData.subGuestType == 'ridingTollTicket';
      default:
        break;
    }
    return defaultValue;
  }

  // public isAdditionallyMandatory(fieldName: string): boolean {
  //   //Donations
  //   if(this.isDonation() && (fieldName === 'email' || fieldName === 'donationValue')) {
  //     return true;
  //   }

  //   // if (this.bIObject.isAnonymous && fieldName === 'email') {
  //   //   return false;
  //   // }
  //   if (fieldName === 'cellphoneNumber' || fieldName === 'email') {
  //     if (this.bIObject.birthday && moment().diff(this.bIObject.birthday, 'years') <= 14) {
  //       return false;
  //     }
  //   }
  //   const fields = this.additionalMandatoryFields;
  //   const field = fields.find(f => f.guestType === this.bIObject.guestType && f.fieldName === fieldName && f.isAnonymous == this.bIObject.isAnonymous);
  //   return (field && field.isMandatory) || false;
  // }

  public getFieldError(fieldName: string): ValidationError | null {
    const error = this.bIObject.bIObjectData.errors.find(e => e.property === fieldName);
    return error || null;
  }

  public getFieldWarnings(fieldName: string): string[] | null {
    const warnings = this.warnings.filter(e => e.property === fieldName);
    return warnings.length ? warnings.map(w => w.message) : null;
  }

  public removeFieldError(fieldName: string): void {
    let index = 0;
    this.bIObject.bIObjectData.errors.forEach((err, i) => {
      if (err.property === fieldName) {
        index = i;
      }
    });
    this.bIObject.bIObjectData.errors.splice(index, 1);
  }

  public get hasOptions(): boolean {
    if (!this.commune) {
      return false;
    }

    const options = this.priceDiscountOptions;
    return options && options.length > 0;
  }

  //Option functions
  public optionActivate(
    option: PriceDiscountOptionProjection,
    callback: (id: number, values: { [fieldName: string]: any }) => void
  ): void {
    if (option.disabled) {
      return;
    }
    const options = this.bIObject.bIObjectData.option;
    if (Object.keys(options).length > 0 && !options[option.id]) {
      this.$store.commit('openOverlay', {
        overlayName: 'Info',
        overlayData: {
          title: i18next.t('booking.discount.tooManyOptions.dialog.title'),
          message: i18next.t('booking.discount.tooManyOptions.dialog.title'),
        },
      });
      return;
    }

    if (this.isOptionActivated(option)) {
      this.bIObject.bIObjectData.option = {};
      this.$emit('option-activate', {});
    } else if (option.attributes === null) {
      this.bIObject.bIObjectData.option[option.id] = {};
      this.$emit('booking-item-object-changed', this.index, this.bIObject);
      this.emitUpdatePrices();
      //this.$forceUpdate();
    } else {
      this.$emit('option-activate', { option, callback });
    }
  }

  public getOptionSubmitCallback(
    option: PriceDiscountOptionProjection,
    bIObject: BIObject
  ): (id: number, values: { [fieldName: string]: any }) => void {
    return (priceDiscountId: number, values: { [fieldName: string]: any }) => {
      bIObject.bIObjectData.option = { [priceDiscountId]: values };
      if (values.chaperoneIsPet) {
        bIObject.bIObjectData.petCount = 1;
      }
      this.$forceUpdate();
    };
  }

  public isOptionActivated(option: PriceDiscountOptionProjection): boolean {
    return option.granted || this.bIObject.bIObjectData.option[option.id] !== undefined;
  }


  // Group Option functions
  public get hasGroupOptions(): boolean {
    if (!this.commune) {
      return false;
    }

    const options = this.groupPriceDiscountOptions;
    return options && options.length > 0;
  }

  public groupOptionActivate(
    option: PriceDiscountOptionProjection,
    callback: (id: number, values: { [fieldName: string]: any }) => void
  ): void {
    if (option.disabled) {
      return;
    }
    const options = this.bIObject.bIObjectData.groupOption;
    if (Object.keys(options).length > 0 && !options[option.id]) {
      this.$store.commit('openOverlay', {
        overlayName: 'Info',
        overlayData: {
          title: i18next.t('booking.discount.tooManyOptions.dialog.title'),
          message: i18next.t('booking.discount.tooManyOptions.dialog.title'),
        },
      });
      return;
    }

    if (this.isGroupOptionActivated(option)) {
      this.bIObject.bIObjectData.groupOption = {};
      this.$emit('option-activate', {});
    } else if (option.attributes === null) {
      this.bIObject.bIObjectData.groupOption[option.id] = {};
      this.$emit('booking-item-object-changed', this.index, this.bIObject);
      this.emitUpdatePrices();
    } else {
      this.$emit('option-activate', { option, callback });
    }
  }

  public getGroupOptionSubmitCallback(
    option: PriceDiscountOptionProjection,
    bIObject: BIObject
  ): (id: number, values: { [fieldName: string]: any }) => void {
    return (priceDiscountId: number, values: { [fieldName: string]: any }) => {
      bIObject.bIObjectData.groupOption = { [priceDiscountId]: values };
      if (values.chaperoneIsPet) {
        bIObject.bIObjectData.petCount = 1;
      }
      this.$forceUpdate();
    };
  }

  public isGroupOptionActivated(option: PriceDiscountOptionProjection): boolean {
    return option.granted || this.bIObject.bIObjectData.groupOption[option.id] !== undefined;
  }

  public onAnnualYearChange(year: number): void {
    this.bIObject.bIObjectData.stayBegin = moment()
      .year(year)
      .startOf('year');
    this.bIObject.bIObjectData.stayEnd = moment()
      .year(year)
      .endOf('year');
  }

  public changeGuestType(guestTypeOption: CommuneGuestTypeOption): void {
    this.canUpdatePrices = false;
    this.bIObject.bIObjectData.isAnnual = guestTypeOption.isAnnual;
    this.bIObject.bIObjectData.guestType = guestTypeOption.guestType;
    this.bIObject.bIObjectData.subGuestType = guestTypeOption.subGuestType ? guestTypeOption.subGuestType : '';

    //clear additionalGuestTypeFields
    this.bIObject.additionalGuestTypeFields = new AdditionalGuestTypeFields();

    if (guestTypeOption.isAnnual) {
      this.bIObjectAnnualYear = moment().year();
    }
    // ToDo: Add reset of fields for not visible fields when switching between guesttypes
    if (!this.canDisplayElement('addressStreetAndNumber')) {
      this.bIObject.bIObjectData.addressStreetAndNumber = '';
    }
    this.$nextTick(() => this.adjustDatesForGuestType());
  }

  private adjustDatesForGuestType() {
    if (this.bIObject.bIObjectData.isAnnual) {
      this.bIObject.bIObjectData.stayBegin = moment()
        .startOf('year')
      this.bIObject.bIObjectData.stayEnd = moment().endOf('year');
    } else if (this.bIObject.bIObjectData.guestType == GuestTypesEnum.day && this.bIObject.bIObjectData.subGuestType == 'ridingTollTicket') {
      this.bIObject.bIObjectData.stayBegin =  momentStartDay(moment());
    } else {
      this.bIObject.bIObjectData.stayBegin = momentStartDay(moment());
      this.adjustStayEndForGuestType();
    }
    this.canUpdatePrices = true;
  }

  private adjustStayEndForGuestType() {
    switch (this.bIObject.bIObjectData.guestType) {
      case GuestTypesEnum.day:
        if (this.bIObject.bIObjectData.subGuestType == 'ridingTollTicket') {
          if (this.bIObject.additionalGuestTypeFields.ridingTollTicketType == 3) {
            this.bIObject.bIObjectData.stayEnd = momentEndDay(moment(this.bIObject.bIObjectData.stayBegin)).add(2, 'days'); 
          }
        }
        else if (this.bIObject.bIObjectData.subGuestType == 'niederrhein4DayTicket') {
          this.bIObject.bIObjectData.stayEnd = momentEndDay(moment(this.bIObject.bIObjectData.stayBegin)).add(3, 'days');
        }
        else if (this.bIObject.bIObjectData.subGuestType == 'niederrhein365DayTicket') {
          this.bIObject.bIObjectData.stayEnd = momentEndDay(moment(this.bIObject.bIObjectData.stayBegin)).add(364, 'days');
        } else {
          this.bIObject.bIObjectData.stayEnd = momentEndDay(moment(this.bIObject.bIObjectData.stayBegin));
        }
        break;
      case GuestTypesEnum.overnight:
        if (!this.bIObject.bIObjectData.stayEnd) {
          this.bIObject.bIObjectData.stayEnd = momentEndDay(moment(this.bIObject.bIObjectData.stayBegin)).add(1, 'day');
        }
        else if (
          (this.bIObject.bIObjectData.stayEnd.isSameOrBefore(this.bIObject.bIObjectData.stayBegin, 'day') ||
            this.bIObject.bIObjectData.stayEnd.isSame(moment().endOf('year'))) &&
          !this.bIObject.bIObjectData.isAnnual
        ) {
          this.bIObject.bIObjectData.stayEnd = momentEndDay(moment(this.bIObject.bIObjectData.stayBegin)).add(1, 'day');
        }
        break;
    }
  }

  public get disabilityOptionChaperoneIsPet(): boolean {
    if (!this.bIObject.bIObjectData.option) {
      return false;
    }

    const option = this.bIObject.bIObjectData.option[Object.keys(this.bIObject.bIObjectData.option)[0]];
    if (!option) {
      return false;
    }

    return option.chaperoneIsPet;
  }

  onAccommodationSelected(accommodation: AccommodationProjection) {
    this.bIObject.bIObjectData.accommodation = accommodation;
  }

  get personLabelCount() {
    if (this.bIObject.bIObjectData.guestType === GuestTypesEnum.overnight && this.showPersonCount && this.index === 0) {
      return 'booking.personGroupCount.label';
    }
    return `booking.personCount.label`;
  }

  public get shouldDisplayGuestTypeSelector() {
    const webConfig = this.commune.webConfiguration;
    if (webConfig) {
      return webConfig.showGuestTypeSelector;
    }
    return true;
  }

  public get shouldStayBeginBeDisabled() {
    const webConfig = this.commune.webConfiguration;
    if (webConfig && webConfig.elements && webConfig.elements.hasOwnProperty('stayBegin_disabled')) {
      return webConfig.elements['stayBegin_disabled'];
    }
    return this.isDayGuest() && this.commune.dayGuestOnlyToday;
  }
}
